import React, {useState, useEffect, createContext } from "react";

import { useNavigate} from "react-router-dom";

// mock
import account from '../_mock/account';

import {api, createSession} from '../services/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) =>{

    const navigate = useNavigate();
    const [usuario, setUser] = useState();
    const [loading, setLoading] = useState(true); 

    useEffect(() => {
        const recuperaUser = localStorage.getItem(['usuario']);
        const recuperaEmpresa = localStorage.getItem(['id_empresa']);
        const recuperaToken = localStorage.getItem(['token']);

        account.displayName = localStorage.getItem(['usuario']);
        account.email = localStorage.getItem(['email']);
        account.descricaoEmpresa = localStorage.getItem(['descricao_empresa']);
        
        if (recuperaUser && recuperaToken && recuperaEmpresa) {

            setUser(recuperaUser);

            api.defaults.headers.Authorization = `Bearer ${recuperaToken}`;
            api.defaults.data = {usuario: recuperaUser, id_empresa: recuperaEmpresa};
        }
        setLoading(false);
    },[]);

    const login = async (usuario, senha) => {
        const response = await createSession(usuario, senha);  
        if(response.erro) {
            return response;
        } 

        setUser(response.data.usuario);
        
        localStorage.setItem("usuario", response.data.usuario);
        localStorage.setItem("id_empresa", response.data.id_empresa);
        localStorage.setItem("email", response.data.email);
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("descricao_empresa", response.data.descricao);
        
        const menuRestrito = response.data.menu_restrito;

        account.displayName = response.data.usuario;
        account.email = response.data.email;
        account.descricaoEmpresa = response.data.descricao;

        api.defaults.headers.Authorization = `Bearer ${response.data.token}`;
        api.defaults.data = {usuario: response.data.usuario, id_empresa: response.data.id_empresa};

        if (menuRestrito === 1){
            navigate("/venda/consultar");
        }else{
            navigate("/indicadores/app");   
        }
    };

    const logout = () => {
        localStorage.removeItem("usuario");
        localStorage.removeItem("id_empresa");
        localStorage.removeItem("email");
        localStorage.removeItem("token");
        localStorage.removeItem("tipo_comercio");
        localStorage.removeItem("menu_restrito");
        localStorage.removeItem("descricao_empresa");
        api.defaults.headers.Authorization = null;
        setUser(null);
        navigate("/login");
    };


    return(
        <AuthContext.Provider value={{authenticated: !!usuario, usuario, loading ,login, logout}}>
            {children}
        </AuthContext.Provider>    
    );
}